"use strict";
var import_vitest = require("vitest");
var import_matchers = require("./matchers");
(0, import_vitest.describe)(import_matchers.stripGroupSegmentsFromPath, function() {
  (0, import_vitest.it)(`strips group segments, preserving initial slash`, function() {
    (0, import_vitest.expect)((0, import_matchers.stripGroupSegmentsFromPath)("/[[...foobar]]/(foo)/bar/[bax]/(other)")).toBe("/[[...foobar]]/bar/[bax]");
    (0, import_vitest.expect)((0, import_matchers.stripGroupSegmentsFromPath)("(foo)/(bar)")).toBe("");
  });
});
(0, import_vitest.describe)(import_matchers.matchGroupName, function() {
  (0, import_vitest.it)(`matches`, function() {
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("[[...foobar]]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("[[foobar]]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("[...foobar]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("[foobar]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("(foobar)")).toEqual("foobar");
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("(foo,bar)")).toEqual("foo,bar");
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("((foobar))")).toEqual("(foobar)");
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("(...foobar)")).toEqual("...foobar");
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("foobar")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("leading/foobar")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("leading/(foobar)")).toEqual("foobar");
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("leading/((foobar))")).toEqual("(foobar)");
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("leading/(...foobar)")).toEqual("...foobar");
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("leading/(foo,bar)")).toEqual("foo,bar");
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("leading/foobar/trailing")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("leading/(foobar)/trailing")).toEqual("foobar");
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("leading/((foobar))/trailing")).toEqual("(foobar)");
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("leading/(...foobar)/trailing")).toEqual("...foobar");
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("leading/(foo,bar)/trailing)")).toEqual("foo,bar");
    (0, import_vitest.expect)((0, import_matchers.matchGroupName)("leading/(foo,bar)/(fruit,apple)")).toEqual("foo,bar");
  });
});
(0, import_vitest.describe)(import_matchers.matchDynamicName, function() {
  (0, import_vitest.it)(`matches`, function() {
    (0, import_vitest.expect)((0, import_matchers.matchDynamicName)("[[...foobar]]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchDynamicName)("[[foobar]]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchDynamicName)("[...foobar]")).toEqual({
      name: "foobar",
      deep: true
    });
    (0, import_vitest.expect)((0, import_matchers.matchDynamicName)("[foobar]")).toEqual({
      name: "foobar",
      deep: false
    });
    (0, import_vitest.expect)((0, import_matchers.matchDynamicName)("foobar")).toEqual(void 0);
  });
});
(0, import_vitest.describe)(import_matchers.matchDeepDynamicRouteName, function() {
  (0, import_vitest.it)(`matches`, function() {
    (0, import_vitest.expect)((0, import_matchers.matchDeepDynamicRouteName)("[[...foobar]]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchDeepDynamicRouteName)("[[foobar]]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchDeepDynamicRouteName)("[...foobar]")).toEqual("foobar");
    (0, import_vitest.expect)((0, import_matchers.matchDeepDynamicRouteName)("[foobar]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchDeepDynamicRouteName)("foobar")).toEqual(void 0);
  });
});
(0, import_vitest.describe)(import_matchers.getNameFromFilePath, function() {
  (0, import_vitest.it)(`should return the name of the file`, function() {
    (0, import_vitest.expect)((0, import_matchers.getNameFromFilePath)("./pages/home.tsx")).toBe("pages/home");
    (0, import_vitest.expect)((0, import_matchers.getNameFromFilePath)("../pages/home.js")).toBe("pages/home");
    (0, import_vitest.expect)((0, import_matchers.getNameFromFilePath)("./(home).jsx")).toBe("(home)");
    (0, import_vitest.expect)((0, import_matchers.getNameFromFilePath)("../../../(pages)/[any]/[...home].ts")).toBe("(pages)/[any]/[...home]");
  });
});
(0, import_vitest.describe)(import_matchers.matchArrayGroupName, function() {
  (0, import_vitest.it)(`should not match routes without groups`, function() {
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("[[...foobar]]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("[[foobar]]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("[...foobar]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("[foobar]")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("foobar")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("leading/foobar")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("leading/foobar/trailing")).toEqual(void 0);
  });
  (0, import_vitest.it)(`should not match routes with a single group`, function() {
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(foobar)")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("((foobar))")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(...foobar)")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("leading/(foobar)")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("leading/((foobar))")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("leading/(...foobar)")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("leading/(foobar)/trailing")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("leading/((foobar))/trailing")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("leading/(...foobar)/trailing")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/foobar")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/(foobar)")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/((foobar))")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/(...foobar)")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/foobar/trailing")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/(foobar)/trailing")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/((foobar))/trailing")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/(...foobar)/trailing")).toEqual(void 0);
  });
  import_vitest.it.skip(`should match routes with array group syntax`, function() {
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(foo,bar)")).toEqual("foo,bar");
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("leading/(foo,bar)")).toEqual("foo,bar");
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("leading/(foo,bar)/trailing)")).toEqual("foo,bar");
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("leading/((foo),(bar))/trailing)")).toEqual("(foo),(bar)");
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("leading/(foo,bar)/(fruit,apple)")).toEqual("foo,bar");
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/(foo,bar)")).toEqual("foo,bar");
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/(foo,bar)/trailing)")).toEqual("foo,bar");
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/((foo),(bar))/trailing)")).toEqual("(foo),(bar)");
  });
  import_vitest.it.skip(`should only match the first group with array group syntax`, function() {
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/(foo,bar)/(fruit,apple)")).toEqual("foo,bar");
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/((foo),bar)/(fruit,apple)")).toEqual("(foo),bar");
    (0, import_vitest.expect)((0, import_matchers.matchArrayGroupName)("(leading)/(foo,bar)/((fruit),apple)")).toEqual("foo,bar");
  });
});
(0, import_vitest.describe)(import_matchers.matchDirectoryRenderMode, function() {
  (0, import_vitest.it)("should match directory names with render mode suffixes", function() {
    (0, import_vitest.expect)((0, import_matchers.matchDirectoryRenderMode)("dashboard+ssr")).toEqual({
      name: "dashboard",
      renderMode: "ssr"
    });
    (0, import_vitest.expect)((0, import_matchers.matchDirectoryRenderMode)("blog+ssg")).toEqual({
      name: "blog",
      renderMode: "ssg"
    });
    (0, import_vitest.expect)((0, import_matchers.matchDirectoryRenderMode)("admin+spa")).toEqual({
      name: "admin",
      renderMode: "spa"
    });
    (0, import_vitest.expect)((0, import_matchers.matchDirectoryRenderMode)("api-routes+api")).toEqual({
      name: "api-routes",
      renderMode: "api"
    });
  });
  (0, import_vitest.it)("should not match directory names without render mode suffixes", function() {
    (0, import_vitest.expect)((0, import_matchers.matchDirectoryRenderMode)("dashboard")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchDirectoryRenderMode)("blog")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchDirectoryRenderMode)("admin")).toEqual(void 0);
  });
  (0, import_vitest.it)("should not match invalid render modes", function() {
    (0, import_vitest.expect)((0, import_matchers.matchDirectoryRenderMode)("dashboard+invalid")).toEqual(void 0);
    (0, import_vitest.expect)((0, import_matchers.matchDirectoryRenderMode)("blog+csr")).toEqual(void 0);
  });
  (0, import_vitest.it)("should handle directory names with hyphens and underscores", function() {
    (0, import_vitest.expect)((0, import_matchers.matchDirectoryRenderMode)("my-dashboard+ssr")).toEqual({
      name: "my-dashboard",
      renderMode: "ssr"
    });
    (0, import_vitest.expect)((0, import_matchers.matchDirectoryRenderMode)("my_blog+ssg")).toEqual({
      name: "my_blog",
      renderMode: "ssg"
    });
  });
});
//# sourceMappingURL=matchers.test.js.map
